import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FindLoad, Images, toCamelCase, useModal } from 'utils';
import { CustomDelete, CustomizedSwitch, NoItemsYet, SimpleTooltip } from 'components';
import { fundingSourceActions } from 'store';
import { PayerEnrollmentItem } from './constants';
import { AddEnrollment } from './modals';
import { clearingHouseTypeEnums } from '../../createFundingSource/constant';
import moment from 'moment/moment';
import { Skeleton } from '@mui/material';

const ACTIVE_INACTIVE_ACTION_TYPE = 'CHANGE_PAYER_ENROLLMENT_STATUS';
const ENROLLMENT_ACTION_TYPE = 'GET_PAYER_CAPABILITIES';
export const PayerEnrollments = ({}) => {
    const payer = useSelector((state) => state.fundingSource.fundingSourceItem);
    const payerCapabilities = useSelector((state) => state.fundingSource.payerCapabilities);
    const { open } = useModal();
    const dispatch = useDispatch();
    const loader = FindLoad(ENROLLMENT_ACTION_TYPE);
    const tlClearinghouse = payer?.payerIds?.find((i) => i.clearinghouse === clearingHouseTypeEnums.TL_CLEARINGHOUSE);
    const currentPayer = payerCapabilities?.items?.find((i) => i?.payer?.primaryPayerId === tlClearinghouse?.id);

    useEffect(() => {
        if (payer?.payerIds?.length) {
            if (tlClearinghouse?.id) {
                dispatch(fundingSourceActions.getPayerCapabilities({ pageSize: 50, query: tlClearinghouse?.id }));
            }
        }
    }, [payer]);

    const activateInactivateEnrollment = (item) => {
        const status = !item?.canUse;
        const innerText = status ? 'Activate' : 'Deactivate';
        const modalTitle = status ? 'Activate Enrollment?' : 'Deactivate Enrollment?';
        const modalDesc = status
            ? 'Are you sure you want to activate this enrollment? This will re-enable transactions for the connected payer.'
            : 'Are you sure you want to deactivate this enrollment? Transactions associated with this payer will be temporarily disabled.';

        open(
            <CustomDelete
                info={modalTitle}
                text={modalDesc}
                innerText={innerText}
                handleDel={() => dispatch(fundingSourceActions.changePayerEnrollmentStatus(payer?.id, item?.enrollmentId, status))}
                actionType={ACTIVE_INACTIVE_ACTION_TYPE}
                color={'blue'}
                body={
                    <div className="deleting-client-info-box">
                        <img src={Images.fileBlack} alt="icon" />
                        <p style={{ fontWeight: 600 }}>Enrollment ID: {item?.enrollmentId}</p>
                    </div>
                }
            />
        );
    };

    return (
        <div>
            <div className="enrollment-overview-wrapper">
                <div>
                    <p className="enrollment-overview-title">Enrollment Overview</p>
                    {loader?.length ? (
                        <div className="enrollment-overview-body">
                            <Skeleton variant="rounded" width={250} height={36} />
                            <Skeleton variant="rounded" width={250} height={36} />
                            <Skeleton variant="rounded" width={250} height={36} />
                            <Skeleton variant="rounded" width={250} height={36} />
                        </div>
                    ) : (
                        <div className="enrollment-overview-body">
                            <PayerEnrollmentItem
                                title={'Professional Claim Submission:'}
                                value={toCamelCase(currentPayer?.payer?.transactionSupport?.professionalClaimSubmission)}
                            />
                            <PayerEnrollmentItem
                                title={'Eligibility Check:'}
                                value={toCamelCase(currentPayer?.payer?.transactionSupport?.eligibilityCheck)}
                            />
                            <PayerEnrollmentItem
                                title={'Claim Status:'}
                                value={toCamelCase(currentPayer?.payer?.transactionSupport?.claimStatus)}
                            />
                            <PayerEnrollmentItem
                                title={'Claim Payment:'}
                                value={toCamelCase(currentPayer?.payer?.transactionSupport?.claimPayment)}
                            />
                        </div>
                    )}
                </div>

                {tlClearinghouse?.id ? (
                    <button onClick={() => open(<AddEnrollment />)} className="add-enrollment-btn">
                        <img src={Images.newServiceAdded} alt="add" />
                        <p>Add Enrollment</p>
                    </button>
                ) : (
                    <SimpleTooltip disable={true} title="This payer does not have a TL Clearinghouse Payer ID." placement="right" arrow>
                        <button disabled={true} style={{ opacity: 0.5 }} className="add-enrollment-btn">
                            <img src={Images.newServiceAdded} alt="add" />
                            <p>Add Enrollment</p>
                        </button>
                    </SimpleTooltip>
                )}
            </div>

            <div className="enrollment-items-wrapper">
                {payer?.enrollments?.length ? (
                    payer?.enrollments?.map((i, j) => (
                        <div
                            key={j}
                            className="enrollment-overview-wrapper"
                            style={{
                                width: 390,
                                flexDirection: 'column',
                                alignItems: 'flex-start',
                            }}
                        >
                            <div className="space-between-align-center">
                                <div className="enrollment-id">
                                    <p>Enrollment ID: </p>
                                    <p>{i?.enrollmentId}</p>
                                </div>

                                <SimpleTooltip
                                    // title={'Deactivate this enrollment'}
                                    title={!i?.canUse ? 'Activate this enrollment' : 'Deactivate this enrollment'}
                                    placement="right"
                                    arrow
                                >
                                    <div>
                                        <CustomizedSwitch
                                            checked={i?.canUse}
                                            name="mergeBilling"
                                            handleClick={() => activateInactivateEnrollment(i)}
                                        />
                                    </div>
                                </SimpleTooltip>
                            </div>

                            <div className="enrollment-item-info-body">
                                <PayerEnrollmentItem title={'Created'} value={'10/16/2025'} />
                                <div style={{ margin: '4px 0' }}>
                                    <PayerEnrollmentItem title={'Transaction Type:'} value={'Claim Submission'} />
                                </div>
                                <div>
                                    <div className="enrollment-item-box" style={{ flexDirection: 'column' }}>
                                        <div className="flex-align-center">
                                            <p>Status: </p>
                                            <span>{toCamelCase(i?.status)}</span>
                                        </div>
                                        {i?.statusLastUpdatedAt && (
                                            <div className="flex-align-center">
                                                <p>Status Date: </p>
                                                <span>{moment.utc(i?.statusLastUpdatedAt).format('MM/DD/YYYY')}</span>
                                            </div>
                                        )}
                                        <div className="flex-align-center">
                                            <p>Reason: </p>
                                            <span>{i?.reason ? i?.reason : '--'}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))
                ) : (
                    <NoItemsYet
                        text={`No Enrollments yet`}
                        // containerStyles={height === 'auto' ? { padding: '20px 0' } : {}}
                    />
                )}
            </div>
        </div>
    );
};
